var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataFalse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2489 15.9935L30.4996 8.75013C32.5001 6.75373 32.5001 3.5033 30.4996 1.5069C28.4965 -0.502299 25.2507 -0.502299 23.2489 1.5069L15.9994 8.75013L8.74988 1.5069C6.74936 -0.502299 3.50347 -0.502299 1.50039 1.5069C-0.50013 3.5033 -0.50013 6.75373 1.50039 8.75013L8.74988 15.9935L1.50039 23.2497C-0.50013 25.2461 -0.50013 28.4967 1.50039 30.4931C3.50347 32.5023 6.74936 32.5023 8.74988 30.4931L15.9994 23.2497L23.2489 30.4931C25.2507 32.5023 28.4965 32.5023 30.4996 30.4931C32.5001 28.4967 32.5001 25.2461 30.4996 23.2497L23.2489 15.9935Z",
    fill: "#FE3C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFalse);
export default __webpack_public_path__ + "static/media/data_false.402f4b5e0d24b1c9d9191e889393d736.svg";
export { ForwardRef as ReactComponent };